import React, { useEffect, useState } from "react";
import { api, brl, formatDate } from "../../lib/api";
import { StatusBadge } from "../../components/Score";
import { QrCode } from "@phosphor-icons/react";
import PixChargeModal from "../../components/PixChargeModal";

export default function ClientInstallments() {
  const [items, setItems] = useState([]);
  const [pixInstId, setPixInstId] = useState(null);

  const load = async () => setItems((await api.get("/installments")).data);
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="client-installments-page">
      <div className="topbar">
        <h1 className="font-display text-4xl font-bold tracking-tight">Minhas Parcelas</h1>
      </div>

      <div className="table-wrap">
        <table className="crl">
          <thead><tr><th>Venda</th><th>Parcela</th><th>Vencimento</th><th>Valor</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}>
                <td>#{it.sale_id.slice(0, 8)}</td>
                <td>{it.number}</td>
                <td className="text-[#5C5A57] text-xs">{formatDate(it.due_date)}</td>
                <td className="tabular font-medium">{brl(it.amount)}</td>
                <td><StatusBadge status={it.status} /></td>
                <td>
                  {it.status !== "paid" && (
                    <button onClick={() => setPixInstId(it.id)} className="text-xs tracking-widest uppercase font-medium text-[#3B6E5E] hover:underline flex items-center gap-1" data-testid={`pay-${it.id}`}><QrCode size={14} /> Pagar com PIX</button>
                  )}
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="6" className="text-center text-sm text-[#5C5A57] py-8">Voce nao tem parcelas pendentes.</td></tr>}
          </tbody>
        </table>
      </div>

      <PixChargeModal
        installmentId={pixInstId}
        open={!!pixInstId}
        onClose={() => setPixInstId(null)}
        onSettled={() => { setPixInstId(null); load(); }}
      />
    </div>
  );
}
